/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Property_TypeInputs */

const cs_form_property_type = /** @type {(inputs: Form_Property_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ nemovitosti`)
};

const en_form_property_type = /** @type {(inputs: Form_Property_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property type`)
};

/**
* | output |
* | --- |
* | "Property type" |
*
* @param {Form_Property_TypeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_property_type = /** @type {((inputs?: Form_Property_TypeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Property_TypeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_property_type(inputs)
	return cs_form_property_type(inputs)
});